module.exports = __webpack_public_path__ + "static/fonts/PorscheNextWCy-Italic.54a41ed4.woff";